import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CartIconStyle = styled(Box)(
  () => `
  color: black;
  display: flex;
  position: relative;
  button {
    min-width: 40px;
    border-radius: 50%;
  }

  .MuiBadge-badge {
    background: #e31b0c;
    color: white;
  }
  `,
);
